import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import auth from './modules/auth'
import survey from './modules/survey'
import surveySingapore from './modules/surveySg'
import surveySydney from './modules/surveySydney'
import taola from './modules/taola'
import surveySapporo from './modules/surveySapporo'
import myprotein from './modules/myprotein'

import salesDashBoard from './modules/dashboard'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    user,
    auth,
    // survey,
    surveySingapore,
    surveySydney,
    taola,
    surveySapporo,
    salesDashBoard,
    myprotein
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js